"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportPreviewRequestSchema = exports.REPORT_TYPE_CATALOG = exports.reportTypeSchema = exports.REPORT_TYPES = exports.ReportType = void 0;
const zod_1 = require("zod");
/** Validates an ISO calendar date string (YYYY-MM-DD) with local field validation to ensure the date actually exists. */
function isValidCalendarDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match)
        return false;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    // Local-field round-trip check (never UTC-string parsing, which silently
    // rolls an out-of-range day/month into the next month/year instead of
    // rejecting it — e.g. `new Date("2026-02-30")` would otherwise "succeed"
    // as 02.03.2026). Same technique as `addLocalDays`
    // (packages/shared-format/src/date.ts) uses for calendar-safe arithmetic.
    const asDate = new Date(year, month - 1, day);
    return (asDate.getFullYear() === year && asDate.getMonth() === month - 1 && asDate.getDate() === day);
}
const isoCalendarDateSchema = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Neispravan format datuma.")
    .refine(isValidCalendarDate, "Datum ne postoji u kalendaru.");
exports.ReportType = {
    WORKER: "WORKER",
    ALL_WORKERS: "ALL_WORKERS",
    PRODUCT: "PRODUCT",
    OPERATION: "OPERATION",
    DAILY_PRODUCTION: "DAILY_PRODUCTION",
    MONTHLY_MANAGEMENT: "MONTHLY_MANAGEMENT",
    NEUTRAL_ACTIVITIES: "NEUTRAL_ACTIVITIES",
    UNNORMED_WORK: "UNNORMED_WORK",
};
exports.REPORT_TYPES = Object.values(exports.ReportType);
exports.reportTypeSchema = zod_1.z.enum([
    "WORKER",
    "ALL_WORKERS",
    "PRODUCT",
    "OPERATION",
    "DAILY_PRODUCTION",
    "MONTHLY_MANAGEMENT",
    "NEUTRAL_ACTIVITIES",
    "UNNORMED_WORK",
]);
exports.REPORT_TYPE_CATALOG = [
    { reportType: "WORKER", requiresEntity: "worker", titleKey: "reportTypes.worker" },
    { reportType: "ALL_WORKERS", requiresEntity: null, titleKey: "reportTypes.allWorkers" },
    { reportType: "PRODUCT", requiresEntity: "product", titleKey: "reportTypes.product" },
    { reportType: "OPERATION", requiresEntity: "operation", titleKey: "reportTypes.operation" },
    { reportType: "DAILY_PRODUCTION", requiresEntity: null, titleKey: "reportTypes.dailyProduction" },
    { reportType: "MONTHLY_MANAGEMENT", requiresEntity: null, titleKey: "reportTypes.monthlyManagement" },
    { reportType: "NEUTRAL_ACTIVITIES", requiresEntity: null, titleKey: "reportTypes.neutralActivities" },
    { reportType: "UNNORMED_WORK", requiresEntity: null, titleKey: "reportTypes.unnormedWork" },
];
exports.reportPreviewRequestSchema = zod_1.z
    .object({
    reportType: exports.reportTypeSchema,
    from: isoCalendarDateSchema,
    to: isoCalendarDateSchema,
    workerId: zod_1.z.string().uuid().optional(),
    productId: zod_1.z.string().uuid().optional(),
    operationId: zod_1.z.string().uuid().optional(),
})
    .refine((v) => v.from <= v.to, { message: "'from' mora biti pre ili jednako 'to'.", path: ["to"] })
    .refine((v) => v.reportType !== "WORKER" || !!v.workerId, {
    message: "workerId je obavezan za izveštaj po radniku.",
    path: ["workerId"],
})
    .refine((v) => v.reportType !== "PRODUCT" || !!v.productId, {
    message: "productId je obavezan za izveštaj po proizvodu.",
    path: ["productId"],
})
    .refine((v) => v.reportType !== "OPERATION" || !!v.operationId, {
    message: "operationId je obavezan za izveštaj po operaciji.",
    path: ["operationId"],
})
    .refine((v) => v.reportType !== "DAILY_PRODUCTION" || v.from === v.to, {
    message: "Dnevni izveštaj zahteva isti datum za 'od' i 'do'.",
    path: ["to"],
});
//# sourceMappingURL=reports.js.map